/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 城市id对象
 */
export default {
  '350100': {
    position: {
      left: '1000px',
      top: '423px'
    },
    collectPosition: {
      left: '158px',
      top: '65px'
    },
    background: require('../../mapPoint/mapPicture/fujian/fuzhou.png')
  },
  '350200': {
    position: {
      left: '922px',
      top: '722px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/xiamen.png')
  },
  '350300': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/putian.png')
  },
  '350400': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/sanming.png')
  },
  '350500': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/quanzhou.png')
  },
  '350600': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/zhangzhou.png')
  },
  '350700': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/nanping.png')
  },
  '350800': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '50px',
      top: '50px'
    },
    background: require('../../mapPoint/mapPicture/fujian/longyan.png')
  },
  '350900': {
    position: {
      left: '1016px',
      top: '261px'
    },
    collectPosition: {
      left: '175px',
      top: '125px'
    },
    background: require('../../mapPoint/mapPicture/fujian/ningde.png')
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/cityPoint/fujian.js
// module id = null
// module chunks = 